export default "__VITE_ASSET__DSfOoyJc__"